import { takeLatest, call, put } from 'redux-saga/effects'

import externalCoursesListAdministration, {
  GetListResponse,
} from 'api/administration/externalCourses/GetList'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import {
  EXTERNAL_COURSES_ADMINISTRATION_GET_LIST,
  Actions,
} from '../../actions/externalCourses.action'
import { ExternalCoursesListParams } from 'api/administration/externalCourses/GetList'

const pattern = EXTERNAL_COURSES_ADMINISTRATION_GET_LIST

export type GetExternalCourseAction = ActionWithPayload<
  typeof pattern,
  ExternalCoursesListParams
>

function* externalCoursesListAdministrationEffectSaga(
  action: GetExternalCourseAction
) {
  try {
    const { page, searchText, sort, usersFilter, perPage, fastFilters } =
      action.payload
    const {
      data,
      total,
      perPage: resPerPage,
    }: GetListResponse = yield call(externalCoursesListAdministration, {
      page,
      searchText,
      sort,
      usersFilter,
      perPage,
      fastFilters,
    })
    yield put(
      Actions.setAdministrationListSuccess(data, total, resPerPage, sort)
    )
  } catch (error) {
    console.error('error: ', error)
    Actions.setLoading(false)
  }
}

export function* externalCoursesListAdministrationWatcherSaga() {
  yield takeLatest(pattern, externalCoursesListAdministrationEffectSaga)
}
